"use client"

import { motion, useScroll, type MotionProps } from "motion/react"

import { cn } from "@/lib/utils"

interface ScrollProgressProps extends Omit<
    React.HTMLAttributes<HTMLElement>,
    keyof MotionProps
> {
    ref?: React.Ref<HTMLDivElement>
    thickness?: string;
}

export function ScrollProgress({
    className,
    ref,
    thickness = "h-[1.5px]",
    ...props
}: ScrollProgressProps) {
    const { scrollYProgress } = useScroll()

    return (
        <motion.div
            ref={ref}
            className={cn(
                `fixed inset-x-0 top-0 z-50 ${thickness} origin-left bg-gradient-to-r from-[#D8959B] via-[#D8959B] to-[#829472]`,
                className
            )}
            style={{
                scaleX: scrollYProgress,
            }}
            {...props}
        />
    )
}
